module.exports = __webpack_public_path__ + "img/entregado.aa4db313.gif";